(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal() {
    var els = document.querySelectorAll('[data-pofipet-reveal]:not(.is-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseInt(e.target.getAttribute('data-pofipet-reveal-delay') || '0', 10);
        setTimeout(function () { e.target.classList.add('is-visible'); }, d);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
  if (document.readyState !== 'loading') reveal();
})();

/* ---- Pofipet motion layer -------------------------------------------- */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (reduce || !fine) return;

  var PAW = '<svg viewBox="0 0 64 56" aria-hidden="true"><ellipse cx="12" cy="16" rx="7" ry="9.5" transform="rotate(-20 12 16)"/><ellipse cx="27" cy="9" rx="7.5" ry="10"/><ellipse cx="43" cy="12" rx="7" ry="9.5" transform="rotate(16 43 12)"/><ellipse cx="56" cy="24" rx="6.5" ry="8.5" transform="rotate(30 56 24)"/><path d="M30 26c-11 0-19 7.6-19 16 0 6.6 5.2 10.5 11.4 10.5 3.1 0 5.3-.8 7.6-1.8 2.3 1 4.5 1.8 7.6 1.8C43.8 52.5 49 48.6 49 42c0-8.4-8-16-19-16z"/></svg>';

  var ring = document.createElement('div');
  ring.className = 'pofipet-cursor';
  var dot = document.createElement('div');
  dot.className = 'pofipet-cursor-dot';
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  var mx = window.innerWidth / 2, my = window.innerHeight / 2;
  var rx = mx, ry = my;
  var lastPawX = mx, lastPawY = my, lastAngle = 0, started = false;

  function onMove(e) {
    mx = e.clientX; my = e.clientY;
    if (!started) {
      started = true;
      rx = mx; ry = my;
      ring.classList.add('is-active');
      dot.classList.add('is-active');
    }
    dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';

    var dx = mx - lastPawX, dy = my - lastPawY;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (dist > 110) {
      lastAngle = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      dropPaw(mx, my, lastAngle);
      lastPawX = mx; lastPawY = my;
    }
  }

  function dropPaw(x, y, angle) {
    var side = Math.random() > 0.5 ? 13 : -13;
    var rad = (angle - 90) * Math.PI / 180;
    var ox = Math.cos(rad + Math.PI / 2) * side;
    var oy = Math.sin(rad + Math.PI / 2) * side;
    var el = document.createElement('div');
    el.className = 'pofipet-paw';
    el.innerHTML = PAW;
    el.style.setProperty('--paw-t', 'translate3d(' + (x + ox) + 'px,' + (y + oy) + 'px,0) rotate(' + angle + 'deg)');
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 1600);
  }

  function raf() {
    rx += (mx - rx) * 0.16;
    ry += (my - ry) * 0.16;
    ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)';
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  document.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mousedown', function () { ring.classList.add('is-press'); });
  document.addEventListener('mouseup', function () { ring.classList.remove('is-press'); });
  document.addEventListener('mouseleave', function () {
    ring.classList.remove('is-active');
    dot.classList.remove('is-active');
  });
  document.addEventListener('mouseenter', function () {
    if (started) { ring.classList.add('is-active'); dot.classList.add('is-active'); }
  });

  var HOVERABLE = 'a, button, summary, label, input[type="radio"], input[type="submit"], .pofipet-btn, [role="button"], .pofipet-bundle__card, select';
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(HOVERABLE)) ring.classList.add('is-hover');
  }, { passive: true });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(HOVERABLE)) ring.classList.remove('is-hover');
  }, { passive: true });

  /* cursor-follow tilt on marked cards */
  function bindTilt() {
    document.querySelectorAll('[data-pofipet-tilt]:not([data-tilt-bound])').forEach(function (el) {
      el.setAttribute('data-tilt-bound', '');
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--tx', ((ev.clientX - r.left) / r.width - 0.5) * 2);
        el.style.setProperty('--ty', ((ev.clientY - r.top) / r.height - 0.5) * 2);
        el.classList.add('is-tilting');
      });
      el.addEventListener('mouseleave', function () {
        el.style.setProperty('--tx', 0);
        el.style.setProperty('--ty', 0);
        el.classList.remove('is-tilting');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', bindTilt);
  document.addEventListener('shopify:section:load', bindTilt);
  if (document.readyState !== 'loading') bindTilt();
})();

/* ---- orbit ribbon: size the ring and tile the text seamlessly -------- */
(function () {
  var ro = null;

  function fit(orbit) {
    var card = orbit.parentElement;
    if (!card) return;
    var r = card.getBoundingClientRect();
    // a detached or not-yet-laid-out card measures ~0. Drawing then would
    // stretch the placeholder viewBox into a blob, so wait for the next tick.
    if (r.width < 60 || r.height < 24) return;
    var w = Math.round(r.width) + 34;
    var h = Math.round(r.height) + 34;
    var svg = orbit.querySelector('svg');
    var path = orbit.querySelector('path');
    if (!svg || !path) return;

    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    var rad = 30, i = 9;
    var lap =
      'M' + (i + rad) + ' ' + i +
      ' H' + (w - i - rad) +
      ' A' + rad + ' ' + rad + ' 0 0 1 ' + (w - i) + ' ' + (i + rad) +
      ' V' + (h - i - rad) +
      ' A' + rad + ' ' + rad + ' 0 0 1 ' + (w - i - rad) + ' ' + (h - i) +
      ' H' + (i + rad) +
      ' A' + rad + ' ' + rad + ' 0 0 1 ' + i + ' ' + (h - i - rad) +
      ' V' + (i + rad) +
      ' A' + rad + ' ' + rad + ' 0 0 1 ' + (i + rad) + ' ' + i;
    // two laps on one open path: the text never crosses a closing point
    path.setAttribute('d', lap + ' ' + lap.replace(/^M[^HAV]*/, ''));
    var L = path.getTotalLength() / 2;

    var label = orbit.getAttribute('data-orbit-label') || '';
    var sep = '  \u2022  ';
    var textEl = orbit.querySelector('text');
    var tp = orbit.querySelector('.pofipet-orbit__tp');
    var wEl = orbit.querySelector('.pofipet-orbit__w');
    if (!textEl || !tp || !wEl) return;

    textEl.style.letterSpacing = '0px';
    wEl.textContent = label + sep;
    var unitW = tp.getComputedTextLength();
    if (!unitW) return;
    var repeats = Math.max(2, Math.floor((L / 1.14) / unitW));
    var full = '';
    for (var k = 0; k < repeats; k++) full += label + sep;
    wEl.textContent = full;
    var natural = tp.getComputedTextLength();
    // fit one lap minus a small whitespace seam
    var extra = (L - natural - 6) / full.length;
    textEl.style.letterSpacing = extra.toFixed(3) + 'px';
    orbit.classList.add('is-fitted');
  }

  function fitAll() { document.querySelectorAll('.pofipet-orbit').forEach(fit); }

  // Re-point the observer at the cards that are on the page right now. A
  // re-rendered section leaves the old ones detached, so rewire from scratch
  // instead of piling up observations on nodes that no longer exist.
  function observe() {
    if (!window.ResizeObserver) return;
    if (ro) ro.disconnect(); else ro = new ResizeObserver(fitAll);
    document.querySelectorAll('.pofipet-orbit').forEach(function (o) {
      if (o.parentElement) ro.observe(o.parentElement);
    });
  }

  // Retry until every ribbon is fitted: right after a section swap the new
  // card can still measure 0, and a ribbon left unfitted stays invisible.
  function boot(tries) {
    fitAll();
    observe();
    if (document.querySelector('.pofipet-orbit:not(.is-fitted)') && (tries || 0) < 8) {
      setTimeout(function () { boot((tries || 0) + 1); }, 120);
    }
  }

  // Dawn swaps the whole product-info block on every variant change and
  // fires no event we can hear on the storefront, so watch the DOM instead.
  function watchDom() {
    if (!window.MutationObserver) return;
    // setTimeout, not requestAnimationFrame: rAF is suspended while the tab
    // is in the background, which would leave the ribbon stuck unfitted.
    var timer = null;
    function schedule() {
      if (timer) return;
      timer = setTimeout(function () { timer = null; boot(); }, 0);
    }
    new MutationObserver(function (records) {
      for (var m = 0; m < records.length; m++) {
        var added = records[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          var isOrbit = node.classList && node.classList.contains('pofipet-orbit');
          if (isOrbit || (node.querySelector && node.querySelector('.pofipet-orbit'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function start() { boot(); watchDom(); }

  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', fitAll);
  if (document.readyState !== 'loading') start();
  setTimeout(fitAll, 600);
})();

/* ---- legacy link fix: /pages/contact -> /pages/iletisim ------------- */
(function () {
  var OLD = '/pages/contact', NEW = '/pages/iletisim';
  if (location.pathname === OLD) { location.replace(NEW + location.search); return; }
  function fix() {
    document.querySelectorAll('a[href="' + OLD + '"], a[href^="' + OLD + '?"]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(OLD, NEW));
    });
  }
  document.addEventListener('DOMContentLoaded', fix);
  document.addEventListener('shopify:section:load', fix);
  if (document.readyState !== 'loading') fix();
})();
